import preval from "babel-plugin-preval/macro";

interface TailwindTheme {
  colors: {
    primary: string;
    primaryDark: string;
    secondary: string;
    secondaryDark: string;
    dark: string;
    light: string;
    neutral: string;
    neutralDark: string;
    neutral2: string;
    success: string;
    warning: string;
    error: string;
    avatarColors: string[];
  };
  screens: Record<string, string>;
}

const theme: TailwindTheme = preval`
const resolveConfig = require("tailwindcss/resolveConfig");
const tailwindConfig = require("../tailwind.config.js");
const tailwindTheme = resolveConfig(tailwindConfig).theme;

//export list of avatar_ hex codes from tailwind.config.js to app
const avatarColors = Object.entries(tailwindTheme.colors).reduce((prev, curr)=>{
  const [key,value] = curr 
  if(key.includes("avatar_")) prev.push(value)
  return prev
},[])

// to limit bundle size we export only what we need
module.exports = {
  colors: {
    primary: tailwindTheme.colors.primary,
    primaryDark: tailwindTheme.colors.primaryDark,
    secondary: tailwindTheme.colors.secondary,
    secondaryDark: tailwindTheme.colors.secondaryDark,
    neutral: tailwindTheme.colors.neutral,
    neutralDark: tailwindTheme.colors.neutralDark,
    success: tailwindTheme.colors.success,
    error: tailwindTheme.colors.error,
    warning: tailwindTheme.colors.warning,
    avatarColors: avatarColors
  },
  screens: tailwindTheme.screens,
};
`;

export default theme;
